/** Parse document calendar dates and API date-times; timezone-less values are UTC. */
export const parseDocumentDate = (value) => {
  if (typeof value !== 'string') return NaN;
  const match = value.trim().match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[T ](\d{2}):(\d{2})(?::(\d{2})(\.\d+)?)?(Z|[+-]\d{2}:?\d{2})?)?$/);
  if (!match) return NaN;
  const [, year, month, day, hour, minute, second, fraction, zone] = match;
  const calendarDate = new Date(0);
  calendarDate.setUTCFullYear(Number(year), Number(month) - 1, Number(day));
  if (calendarDate.getUTCFullYear() !== Number(year) || calendarDate.getUTCMonth() !== Number(month) - 1 ||
      calendarDate.getUTCDate() !== Number(day) || Number(hour || 0) > 23 ||
      Number(minute || 0) > 59 || Number(second || 0) > 59) return NaN;
  const date = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  return Date.parse(`${date}T${hour || '00'}:${minute || '00'}:${second || '00'}${fraction || ''}${zone || 'Z'}`);
};

/** Match the API's UTC calendar-day convention, including the entire expiry day. */
export const getDocumentDaysUntilExpiry = (expiryDate, now = Date.now()) => {
  const expiry = parseDocumentDate(expiryDate);
  const millisecondsPerDay = 24 * 60 * 60 * 1000;
  return Math.floor(expiry / millisecondsPerDay) - Math.floor(Number(now) / millisecondsPerDay);
};

const localCalendarDate = (date) => date instanceof Date && Number.isFinite(date.getTime())
  ? new Date(date.getFullYear(), date.getMonth(), date.getDate()) : null;

/** Validate picker dates as local calendar days, preserving the existing 25-year limits. */
export const validateDocumentUploadDates = (issueDate, expiryDate, now = new Date()) => {
  const today = localCalendarDate(now);
  const issue = localCalendarDate(issueDate);
  const expiry = localCalendarDate(expiryDate);
  let issueError = '';
  let expiryError = '';
  if (!issue) issueError = 'Invalid issue date. dd/MM/yyyy';
  else if (issue > today) issueError = "Issue date can't be set beyond today.";
  else if (issue < new Date(today.getFullYear() - 25, today.getMonth(), today.getDate())) issueError = 'Invalid issue date.';
  if (!expiry) expiryError = 'Invalid expiry date. dd/MM/yyyy';
  else if (expiry < today) expiryError = "You can't use expired document.";
  else if (expiry > new Date(today.getFullYear() + 25, today.getMonth(), today.getDate())) expiryError = 'Invalid expiration date.';
  if (!issueError && !expiryError && expiry < issue) expiryError = 'Expiry date cannot be before issue date.';
  return { issueError, expiryError };
};

/** Keep the selected local calendar day when serializing; do not convert it to UTC. */
export const formatDocumentDateForUpload = (date) => {
  if (!localCalendarDate(date)) return '';
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
};
